import { EventEmitter, Injectable, Output } from '@angular/core';
import { Service } from 'src/app/core/jsonapi/service';
import { AsyncSubject, Observable } from 'rxjs';
import { SMSMessage } from '../_types/sms-message';
import { WhatsappMessage } from '../_types/whatsapp-message';

@Injectable({
  providedIn: 'root'
})
export class WhatsappMessageService extends Service<WhatsappMessage> {
  public override type = 'whatsappMessages';
  public override url = 'communications/whatsappMessages';
  

  public Send(smsMessage: WhatsappMessage): Observable<WhatsappMessage> {
    let url = this.getAPIUrl()+ '/send';    
    return this.http.post<WhatsappMessage>(url, smsMessage);
  }

  //entrantes sin leer que me corresponden. El servidor resuelve quien ve que: tramitador, companeros
  //ausentes de mis contratos y, con CASES.VIEW_ALL_CASES, los que no tienen expediente.
  public GetUnread(): Observable<any[]> {
    let url = this.getAPIUrl() + '/unread';
    return this.http.get<any[]>(url);
  }

  //solo el contador de entrantes sin leer, para el badge del topbar: evita traerse la lista completa
  //(Content, CaseNumber, ClientName) solo para contar.
  public GetUnreadCount(): Observable<number> {
    let url = this.getAPIUrl() + '/unread-count';
    return this.http.get<number>(url);
  }

  //avisa de que se han marcado entrantes como leidos, para que quien muestre la lista de pendientes la
  //recargue. Mismo patron que NotificationsService.onNotificationReaded.
  @Output() onWhatsappReaded = new EventEmitter<void>();

  public MarkRead(phoneNumber: string): Observable<number> {
    let url = this.getAPIUrl() + '/markread';
    let subject = new AsyncSubject<number>();
    this.http.post<number>(url, { phoneNumber: phoneNumber }).subscribe((response: number) => {
      subject.next(response);
      subject.complete();
      if(response > 0) this.onWhatsappReaded.emit();
    });
    return subject.asObservable();
  }

}
